<div class="w-full flex justify-center">
  <button
    class="bg-primary-900 p-2 rounded-full! flex justify-center items-center transition-all duration-200 relative"
    [ngClass]="{
      'rounded-full': isLoading(),
      'w-10': isLoading(),
      'w-full': !isLoading(),
    }"
    (click)="onClick.emit()"
  >
    <p class="uppercase font-bold text-white" [class.opacity-0]="isLoading()">
      {{ text }}
    </p>
    @if (isLoading()) {
      <svg
        class="loader absolute"
        viewBox="0 0 384 384"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          class="active"
          pathLength="360"
          fill="transparent"
          stroke-width="32"
          cx="192"
          cy="192"
          r="176"
        ></circle>
        <circle
          class="track"
          pathLength="360"
          fill="transparent"
          stroke-width="32"
          cx="192"
          cy="192"
          r="176"
        ></circle>
      </svg>
    } @else {}
  </button>
</div>
